import { cn } from "@/lib/utils";
import type { EnquiryStatus } from "@/lib/enquiries";

const STATUS_STYLE: Record<EnquiryStatus, string> = {
  New:       "bg-sky-200 text-sky-900",
  InQuote:   "bg-amber-200 text-amber-900",
  Quoted:    "bg-emerald-200 text-emerald-900",
  Won:       "bg-violet-200 text-violet-900",
  Lost:      "bg-rose-200 text-rose-900",
  Abandoned: "bg-zinc-300 text-zinc-800",
};

export function EnquiryStatusBadge({
  status,
  className,
}: {
  status: EnquiryStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-block rounded px-2 py-0.5 text-xs font-medium",
        STATUS_STYLE[status],
        className,
      )}
    >
      {status}
    </span>
  );
}
